import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';

/**
 * Resolver to determine the default tab for the 'personalize-app' section.
 * It reads from localStorage or defaults to 'logo', then navigates to the
 * route with the determined tab parameter.
 */
export const personalizeAppTabResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<never> | void => {
  const router = inject(Router);
  const defaultTab = 'logo';
  let targetTab = localStorage.getItem('personalizeAppTab');

  if (!targetTab) {
    targetTab = defaultTab;
    localStorage.setItem('personalizeAppTab', targetTab);
  }

  router.navigate(['/myspace/personalize-app', targetTab], { replaceUrl: true });

  return EMPTY;
};
